import { useTranslation } from 'next-i18next/pages'
import styles from './UspCharts.module.scss'

const BoltChart = () => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'price' })

  return (
    <div data-bolt="true" className={styles['chart-wrapper']}>
      <div className={styles.chart}>
        <svg
          width="408"
          height="249"
          viewBox="0 0 408 249"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-describedby="bolt-chart-title"
          role="img"
        >
          <title id="bolt-chart-title">{t('comparison.bolt.alt')}</title>
          <path
            d="M12.9974 149.13L8.99736 149.13L8.99692 157.13L12.9969 157.13L12.9971 153.13L12.9974 149.13ZM400.158 168.506C402.367 168.506 404.158 166.715 404.158 164.506C404.158 162.297 402.367 160.506 400.158 160.506V164.506V168.506ZM12.9971 153.13L12.9969 157.13C14.5676 157.13 20.4048 157.575 29.2105 158.288C37.8762 158.99 49.1649 159.929 61.3454 160.867C85.6626 162.739 113.741 164.627 131.831 164.627V160.627V156.627C114.098 156.627 86.3219 154.767 61.9596 152.891C49.8003 151.954 38.5429 151.018 29.8566 150.315C21.3104 149.622 14.9897 149.13 12.9974 149.13L12.9971 153.13ZM131.831 160.627V164.627C154.401 164.627 177.214 162.85 200.319 161.09C223.473 159.326 246.952 157.575 271.107 157.575V153.575V149.575C246.604 149.575 222.835 151.351 199.711 153.113C176.537 154.878 154.041 156.627 131.831 156.627V160.627ZM271.107 153.575V157.575C295.149 157.575 316.751 160.274 337.719 163.007C358.622 165.731 378.991 168.506 400.158 168.506V164.506V160.506C379.609 160.506 359.781 157.815 338.753 155.074C317.789 152.342 295.724 149.575 271.107 149.575V153.575Z"
            fill="#00F0C8"
          />
          <path d="M1.01099 238.092L404.381 238.863" stroke="#43006D" stroke-width="2.02176" stroke-linecap="round" />
          <path d="M9.82129 247.963L9.82128 3.85539" stroke="#43006D" stroke-width="2.02176" stroke-linecap="round" />
          <path d="M2.42065 9.4082L10.399 1.42984L18.3774 9.4082" stroke="#43006D" stroke-width="2.02176" stroke-linecap="round" />
          <path d="M398.251 231.04L406.229 239.018L398.251 246.997" stroke="#43006D" stroke-width="2.02176" stroke-linecap="round" />
        </svg>

        <strong className={styles.center}>{t('comparison.bolt.description')}</strong>
        <small className={styles.price}>{t('comparison.chartLabels.price')}</small>
        <small className={styles.time}>{t('comparison.chartLabels.time')}</small>
      </div>

      <h2>{t('comparison.bolt.label')}</h2>
    </div>
  )
}

export default BoltChart
